import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import Button from "flarum/common/components/Button";
import humanTime from "flarum/common/helpers/humanTime";
import classList from "flarum/common/utils/classList";
import { ThreadsSkeleton } from "./Skeletons";
import iconLabel from "../utils/iconLabel";
/**
 * Threads: the actor's own across every channel, or all of one channel's.
 *
 * The counterpart to the thread panel: the panel reads one thread, this is how
 * you find it again afterwards. Selecting a row opens the panel over its own
 * channel: on the page by routing, in the drawer by setting the thread on the
 * state, since routing from the drawer closes it.
 */
export default class ThreadsList extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "threads", []);
    _defineProperty(this, "loading", true);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  onbeforeupdate(vnode) {
    var _this$attrs$channelId, _this$attrs, _vnode$attrs$channelI;
    const previous = (_this$attrs$channelId = (_this$attrs = this.attrs) == null ? void 0 : _this$attrs.channelId) != null ? _this$attrs$channelId : null;
    super.onbeforeupdate(vnode);

    // Same component, another channel: the page keeps one mounted instance
    // across chat routes (see ChatPageResolver), so the scope can change under it.
    if (((_vnode$attrs$channelI = vnode.attrs.channelId) != null ? _vnode$attrs$channelI : null) !== previous) {
      this.loading = true;
      this.load();
    }
  }
  view() {
    return m("div", {
      className: classList("ChatThreadsList", {
        "ChatThreadsList--embedded": this.attrs.embedded
      })
    }, this.header(), this.body());
  }

  /**
   * A title, and in the drawer a way back to the conversation. The page's
   * sections carry their own title in the toolbar, so only the scoped list
   * names itself there.
   */
  header() {
    const scoped = Boolean(this.attrs.channelId);
    if (!this.attrs.embedded && !scoped) return null;
    const channel = scoped ? this.attrs.state.channel(Number(this.attrs.channelId)) : null;

    // The panel shell the thread, pinned and search panes use, so every pane
    // that can sit in the drawer's overlay slot is dismissed the same way.
    return m("div", {
      className: "ChatThreadPanel-header"
    }, m("i", {
      className: "fas fa-code-branch",
      "aria-hidden": "true"
    }), m("span", {
      className: "ChatThreadPanel-title"
    }, app.translator.trans("ramon-chat.forum.channel.threads"), channel ? m("span", {
      className: "ChatThreadsList-scope"
    }, channel.displayName()) : null), this.attrs.embedded ? m(Button, Object.assign({
      className: "Button Button--icon Button--flat",
      icon: "fas fa-xmark"
    }, iconLabel(app.translator.trans("ramon-chat.forum.search.close", {}, true)), {
      onclick: this.attrs.onClose
    })) : null);
  }
  body() {
    if (this.loading) return ThreadsSkeleton();
    if (this.threads.length === 0) {
      return m("div", {
        className: "ChatBrowse-empty"
      }, app.translator.trans(this.attrs.channelId ? "ramon-chat.forum.thread.no_threads_in_channel" : "ramon-chat.forum.thread.no_threads"));
    }
    return m("div", {
      className: "ChatThreadsList-rows"
    }, this.threads.map(thread => this.row(thread)));
  }
  row(thread) {
    const channel = this.attrs.state.channel(thread.channelId());
    const at = thread.lastMessageAt();
    return m("button", {
      type: "button",
      key: thread.id(),
      className: classList("ChatThreadsList-row", {
        "ChatThreadsList-row--unread": thread.hasUnread()
      }),
      onclick: () => this.open(thread)
    }, m("i", {
      className: "ChatThreadsList-icon fas fa-comments",
      "aria-hidden": "true"
    }), m("div", {
      className: "ChatThreadsList-body"
    }, m("div", {
      className: "ChatThreadsList-title"
    }, thread.displayTitle()), m("div", {
      className: "ChatThreadsList-meta"
    }, channel && !this.attrs.channelId ? m("span", null, channel.displayName()) : null, m("span", null, app.translator.trans("ramon-chat.forum.thread.replies", {
      count: thread.repliesCount()
    })), at ? m("span", null, humanTime(at)) : null)), thread.hasUnread() ? m("span", {
      className: "ChatThreadsList-badge"
    }, thread.unreadCount()) : null);
  }
  async load() {
    var _this$attrs$channelId2;
    const channelId = (_this$attrs$channelId2 = this.attrs.channelId) != null ? _this$attrs$channelId2 : null;
    try {
      var _this$attrs$channelId3;
      const results = await app.store.find("chat-threads", {
        filter: channelId ? {
          channel: channelId
        } : {
          participating: true
        },
        sort: "-lastMessageAt",
        page: {
          limit: 50
        }
      });

      // A scope that changed while the request was out is not this answer's.
      if (((_this$attrs$channelId3 = this.attrs.channelId) != null ? _this$attrs$channelId3 : null) !== channelId) return;
      this.threads = Array.isArray(results) ? results : [];
    } catch (_unused) {
      this.threads = [];
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  open(thread) {
    const channelId = thread.channelId();
    if (!channelId) return;
    this.attrs.state.setActiveChannel(channelId);

    // In the drawer the thread panel takes this pane's slot; the state is the
    // route there. Closing the list first, or the two would both claim it.
    if (this.attrs.embedded) {
      this.attrs.state.showThreads = false;
      this.attrs.state.activeThreadId = Number(thread.id());
      m.redraw();
      return;
    }
    this.attrs.state.activeThreadId = Number(thread.id());
    m.route.set(app.route("chat.thread", {
      id: channelId,
      threadId: thread.id()
    }));
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ThreadsList', ThreadsList);